import PersonalInfoChild from './PersonalInfoChildContainer';

export default PersonalInfoChild;
